const dateKey = (value) => String(value || '').slice(0, 10);

export const automaticCauseDateOptions = (history = []) => {
    const byDate = new Map();

    history.forEach((observation) => {
        const date = dateKey(observation?.date);
        if (date && !byDate.has(date)) byDate.set(date, observation);
    });

    return [...byDate.values()].sort((left, right) => dateKey(right.date).localeCompare(dateKey(left.date)));
};

export const causeLabelsForAutomaticDate = (history = [], observedOn) => {
    const expectedDate = dateKey(observedOn);
    const labels = automaticCauseDateOptions(history)
        .find((observation) => dateKey(observation.date) === expectedDate)
        ?.causes || [];

    return labels
        .map((cause) => String(cause?.label || '').trim())
        .filter(Boolean);
};

export const automaticCausePayload = (observedOn, labels = []) => ({
    observed_on: dateKey(observedOn),
    causes: [...new Set(labels.map((label) => String(label || '').trim()).filter(Boolean))]
        .map((label) => ({label})),
});
